<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1000px"
    :close-on-click-modal="false"
  >
    <div v-show="!isBatch" style="display: flex;margin: 0 0 10px 10px;color: #1F75D5">
      {{ contractNoPrice.pol }}&nbsp;——————&nbsp;{{ contractNoPrice.pod }}
    </div>
    <div style="display: flex;margin-bottom: 10px">
      <div style="width: 80px;margin-left: 10px;">{{ this.$t('CargoMsg.Cargo_CarrierShip') }}</div>
      <span style="color: #1F75D5">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', contractNoPrice.carrierId, 'chineseName') }}</span>
    </div>
    <div style="display: flex;margin-bottom: 10px">
      <div style="width: 80px;margin-left: 10px;">{{ this.$t('CargoMsg.Cargo_BookingAgent') }}</div>
      <span style="color: #1F75D5">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', contractNoPrice.bookingAgent, 'chineseName') }}</span>
    </div>
    <!-- 应收 -->
    <div style="display: flex;margin-bottom: 5px">
      <b style="margin: 0 10px;line-height: 28px;font-size: 16px;"> {{ $t('Message.Receivable') }}</b>
      <el-button type="primary" @click="arAdd">{{ $t('Partners.add') }}</el-button>
      <el-button type="danger" @click="arDelete">{{ $t('Partners.delete') }}</el-button>
    </div>
    <cargo-ag-grid
      config-module="100404"
      :grid-options="ar.gridOptions"
      :column-defs="ar.columnDefs"
      :row-data="ar.rowData"
      style="width: 100%;min-height: 200px;"
      @gridReady="params=>{ar.gridApi=params.api}"
    />
    <!-- 应付 -->
    <div style="display: flex;margin: 10px 0 5px 0">
      <b style="margin: 0 10px;line-height: 28px;font-size: 16px;"> {{ $t('Message.Payable') }}</b>
      <el-button type="primary" @click="apAdd">{{ $t('Partners.add') }}</el-button>
      <el-button type="danger" @click="apDelete">{{ $t('Partners.delete') }}</el-button>
    </div>
    <cargo-ag-grid
      config-module="100405"
      :grid-options="ap.gridOptions"
      :column-defs="ap.columnDefs"
      :row-data="ap.rowData"
      style="width: 100%;min-height: 200px;"
      @gridReady="params=>{ap.gridApi=params.api}"
    />
    <span slot="footer">
      <b v-show="isBatch" style="float: left">{{ $t('Partners.batchReplaceAfterSave') }}</b>
      <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'
import { ContractNoPriceSurchargeFcl } from '@/class/model/mdm/ContractNoPriceSurchargeFcl'
import { querySurchargeByContractNoPrice, saveContractNoPriceSurchargeFcl } from '@/api/seaExport/contractNo'
import { AutoIncrementNum } from '@/utils/commonUtil'
import lodash from 'lodash'

// sum20、sum40、sumHc、sum45标识数字，在此处和0等同
const NIL = -4294967297

export default {
  name: 'ContractNoSurchargeFclDialog',
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    contractNoPrice: { type: Object, required: true },
    beginDate: { type: String, required: true },
    endDate: { type: String, required: true },
    isBatch: { type: Boolean, required: true },
    contractNoPriceKeys: { type: Array, default: () => [] }
  },
  data() {
    const columnDefs = [
      {
        headerName: '',
        checkboxSelection: true,
        width: 55,
        sortable: false,
        suppressMenu: true,
        suppressSizeToFit: true,
        resizable: false,
        headerCheckboxSelection: true
      },
      {
        headerName: this.$t('Pricing.ChargeType'),
        field: 'chargeType',
        colId: 'chargeType',
        width: 150,
        valueFormatter: params => {
          switch (params.value) {
            case 'S':
              return this.$t('Pricing.Surcharge')
            case 'L':
              return this.$t('Pricing.LocalCharge')
            case 'D':
              return this.$t('Pricing.DesCharge')
          }
          return ''
        },
        editable: true,
        cellEditor: 'CargoAgGridSelectEditor',
        cellEditorParams: {
          selectProps: {
            filterable: true
          },
          options: [{ code: 'S', name: this.$t('Pricing.Surcharge') }, { code: 'L', name: this.$t('Pricing.LocalCharge') }, { code: 'D', name: this.$t('Pricing.DesCharge') }],
          tagName: 'name',
          tagValue: 'code'
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('Pricing.ChargeName'),
        field: 'chargeScaleCode',
        width: 150,
        editable: true,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_ChargeItem,
            methodParams: { active: true },
            tagValue: 'scaleCode',
            tagName: 'zhName',
            filterable: true
          }
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', params.value, 'zhName')
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('Pricing.ChargeUnit'),
        colId: 'unit',
        field: 'unit',
        width: 150,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ChargeMeasure, 'code', params.value, 'chineseName')
        },
        editable: true,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.local_cache_ChargeMeasure,
            tagValue: 'code',
            tagName: 'chineseName',
            methodParams: { unit: true, seaFreight: true },
            filterable: true,
            clearable: false
          }
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('Pricing.VatIncluded'),
        colId: 'vat',
        field: 'vat',
        width: 100,
        valueFormatter: params => {
          return params.value ? 'Y' : 'N'
        },
        editable: true,
        cellEditor: 'CargoAgGridSelectEditor',
        cellEditorParams: {
          selectProps: {
            filterable: true
          },
          options: [{ code: true, name: 'Y' }, { code: false, name: 'N' }],
          tagName: 'name',
          tagValue: 'code'
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('FinanceManage.charge_taxRate'),
        colId: 'taxRate',
        field: 'taxRate',
        width: 150,
        valueFormatter: (params) => {
          return this.$numeral(params.value).format('0.00')
        },
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: (params) => {
          if ((Number(params.newValue) || 0) !== (Number(params.oldValue) || 0)) {
            this.onCellChange(params)
          }
        }
      }, {
        headerName: "20'",
        colId: 'sum20',
        field: 'sum20',
        width: 150,
        valueFormatter: this.numLabelFunction,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: (params) => {
          if ((Number(params.newValue) || 0) !== (Number(params.oldValue) || 0)) {
            this.onCellChange(params)
          }
        }
      }, {
        headerName: "40'",
        colId: 'sum40',
        field: 'sum40',
        width: 150,
        valueFormatter: this.numLabelFunction,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: (params) => {
          if ((Number(params.newValue) || 0) !== (Number(params.oldValue) || 0)) {
            this.onCellChange(params)
          }
        }
      }, {
        headerName: '40HC',
        colId: 'sumHc',
        field: 'sumHc',
        width: 150,
        valueFormatter: this.numLabelFunction,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: (params) => {
          if ((Number(params.newValue) || 0) !== (Number(params.oldValue) || 0)) {
            this.onCellChange(params)
          }
        }
      }, {
        headerName: "45'",
        colId: 'sum45',
        field: 'sum45',
        width: 150,
        valueFormatter: this.numLabelFunction,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: (params) => {
          if ((Number(params.newValue) || 0) !== (Number(params.oldValue) || 0)) {
            this.onCellChange(params)
          }
        }
      }, {
        headerName: this.$t('Pricing.EqType'),
        field: 'eqType',
        colId: 'eqType',
        width: 150,
        editable: true,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_EQType,
            tagValue: 'code',
            tagName: 'code',
            filterable: true,
            filterTagNames: ['code']
          }
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('FinanceManage.charge_unitPrice'),
        colId: 'casePrice',
        field: 'casePrice',
        width: 150,
        valueFormatter: this.numLabelFunction,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 3
          }
        },
        onCellValueChanged: (params) => {
          if ((Number(params.newValue) || 0) !== (Number(params.oldValue) || 0)) {
            this.onCellChange(params)
          }
        }
      }, {
        headerName: this.$t('FinanceManage.charge_currency'),
        colId: 'currency',
        field: 'currency',
        width: 150,
        editable: true,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Currency,
            staticOptions: ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency),
            tagValue: 'code',
            tagName: 'code',
            filterable: true,
            clearable: false
          }
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('Pricing.PaymentTerm'),
        colId: 'payment',
        field: 'payment',
        width: 150,
        valueFormatter: (params) => {
          switch (params.value) {
            case 'P':
              return this.$t('Pricing.Prepaid')
            case 'C':
              return this.$t('Pricing.Collect')
            case 'B':
              return this.$t('Pricing.Both')
          }
          return ''
        },
        editable: true,
        cellEditor: 'CargoAgGridSelectEditor',
        cellEditorParams: {
          selectProps: {
            filterable: true
          },
          options: [{ code: 'P', name: this.$t('Pricing.Prepaid') }, { code: 'C', name: this.$t('Pricing.Collect') }, { code: 'B', name: this.$t('Pricing.Both') }],
          tagName: 'name',
          tagValue: 'code'
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('FinanceManage.charge_remarks'),
        colId: 'remarks',
        field: 'remarks',
        width: 150,
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {},
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('Pricing.Dangerous'),
        colId: 'dangerous',
        field: 'dangerous',
        width: 150,
        valueFormatter: params => {
          return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
        },
        editable: true,
        cellEditor: 'CargoAgGridSelectEditor',
        cellEditorParams: {
          selectProps: {
            filterable: true
          },
          options: [{ code: true, name: this.$t('Message.Yes') }, { code: false, name: this.$t('Message.No') }],
          tagName: 'name',
          tagValue: 'code'
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('Pricing.BeginDateCol'),
        colId: 'beginDate',
        field: 'beginDate',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        onCellValueChanged: (params) => {
          this.onCellChange(params)
        }
      }, {
        headerName: this.$t('SeaExport.ValidTo'),
        colId: 'endDate',
        field: 'endDate',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('Information.IsItManualLaborCost'),
        field: 'manualAdded',
        width: 150,
        valueFormatter: params => {
          return params.value ? 'Y' : 'N'
        }
      }
    ]
    return {
      innerVisible: false,
      TYPE_NAMES,
      ColumnUtils,
      autoIncrementNum: new AutoIncrementNum(),
      originRowData: [],
      ar: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          singleClickEdit: true,
          onRowDataChanged: event => {
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.ar.selectedNode = nodes[event.rowIndex] || null
          },
          onSortChanged: event => {
            if (this.ar.selectedNode) {
              event.api.setFocusedCell(this.ar.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          ...columnDefs,
          {
            headerName: this.$t('Information.FreeOfArCharge'),
            field: 'freeCharge',
            width: 100,
            valueFormatter: params => {
              return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
            },
            cellRendererFramework: 'CargoGridOptCheckBox',
            custom: {
              editable: true,
              trueLabel: 1,
              falseLable: 0,
              valueChanged: (params) => {
                this.onCellChange(params)
              }
            }
          }
        ],
        rowData: [],
        selectedNode: null,
        gridApi: null
      },
      ap: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          singleClickEdit: true,
          onRowDataChanged: event => {
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.ap.selectedNode = nodes[event.rowIndex] || null
          },
          onSortChanged: event => {
            if (this.ap.selectedNode) {
              event.api.setFocusedCell(this.ap.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          ...columnDefs,
          {
            headerName: this.$t('Information.FreeOfApCharge'),
            field: 'freeCharge',
            width: 100,
            valueFormatter: params => {
              return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
            },
            cellRendererFramework: 'CargoGridOptCheckBox',
            custom: {
              editable: true,
              trueLabel: 1,
              falseLable: 0,
              valueChanged: (params) => {
                this.onCellChange(params)
              }
            }
          }
        ],
        rowData: [],
        selectedNode: null,
        gridApi: null
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.ar.rowData = []
        this.ap.rowData = []
      }
    }
  },
  methods: {
    init() {
      querySurchargeByContractNoPrice({ contractNoPriceKey: this.contractNoPrice.uuid, beginDate: this.beginDate, endDate: this.endDate }).then(res => {
        for (const row of res.data) {
          row._seq = this.autoIncrementNum.getNextNum()
        }
        this.originRowData = lodash.cloneDeep(res.data)
        this.ar.rowData = []
        this.ap.rowData = []
        for (const row of res.data) {
          if (row.sum20 === NIL) {
            row.sum20 = 0
          }
          if (row.sum40 === NIL) {
            row.sum40 = 0
          }
          if (row.sumHc === NIL) {
            row.sumHc = 0
          }
          if (row.sum45 === NIL) {
            row.sum45 = 0
          }
          if (row.casePrice === NIL) {
            row.casePrice = 0
          }
          if (row.receivable) {
            this.ar.rowData.push(row)
          } else {
            this.ap.rowData.push(row)
          }
        }
      })
    },
    numLabelFunction(params) {
      const num = Number(params.value) || 0
      if (num === 0) {
        return ''
      }
      return this.$numeral(num).format('0.00')
    },
    arAdd() {
      const obj = new ContractNoPriceSurchargeFcl().fillDefaultValue().getData()
      obj.contractNoPriceUuid = this.contractNoPrice.uuid
      obj.receivable = true
      obj.beginDate = this.beginDate
      obj.endDate = this.endDate
      obj.manualAdded = true
      this.ar.rowData.push(obj)
    },
    arDelete() {
      const selectedRows = this.ar.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return
      }
      for (let i = this.ar.rowData.length - 1; i >= 0; --i) {
        if (selectedRows.includes(this.ar.rowData[i])) {
          this.ar.rowData.splice(i, 1)
        }
      }
    },
    apAdd() {
      const obj = new ContractNoPriceSurchargeFcl().fillDefaultValue().getData()
      obj.contractNoPriceUuid = this.contractNoPrice.uuid
      obj.receivable = false
      obj.beginDate = this.beginDate
      obj.endDate = this.endDate
      obj.manualAdded = true
      this.ap.rowData.push(obj)
    },
    apDelete() {
      const selectedRows = this.ap.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return
      }
      for (let i = this.ap.rowData.length - 1; i >= 0; --i) {
        if (selectedRows.includes(this.ap.rowData[i])) {
          this.ap.rowData.splice(i, 1)
        }
      }
    },
    save() {
      const rowData = [...this.ar.rowData, ...this.ap.rowData]
      for (const row of rowData) {
        if ((Number(row.sum20) || Number(row.sum40) || Number(row.sumHc) || Number(row.sum45)) && Number(row.casePrice)) {
          this.$message.warning(StrUtils.substitute(this.$t('Pricing.EXISTS_SAME_TIME2'), ["20',40',40'HC,45'", this.$t('Pricing.UnitPrice')]))
          return
        }
        if (!row.sum20) {
          row.sum20 = NIL
        }
        if (!row.sum40) {
          row.sum40 = NIL
        }
        if (!row.sumHc) {
          row.sumHc = NIL
        }
        if (!row.sum45) {
          row.sum45 = NIL
        }
        if (!row.casePrice) {
          row.casePrice = NIL
        }
      }
      const editingFields = ['chargeType', 'chargeScaleCode', 'unit', 'vat', 'taxRate', 'sum20', 'sum40', 'sumHc', 'sum45', 'eqType', 'casePrice', 'currency', 'payment', 'remarks', 'beginDate', 'freeCharge']
      for (const row of rowData) {
        const origigRow = this.originRowData.find(item => item._seq === row._seq)
        if (origigRow) {
          for (const field of editingFields) {
            const origigVal = origigRow[field]
            let newVal = row[field]
            if (typeof origigVal === 'number') {
              newVal = Number(newVal) || 0
            }
            if (newVal !== origigVal) {
              row.manualAdded = true
              break
            }
          }
        }
      }
      const loading = getLoading4Cxt(this)
      const contractNoPriceKeys = this.isBatch ? this.contractNoPriceKeys : [this.contractNoPrice.uuid]
      saveContractNoPriceSurchargeFcl(rowData, contractNoPriceKeys).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    onCellChange(params) {
      // const { node } = params
      // node.setDataValue('manualAdded', true)
    }
  }
}
</script>
